// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //

// icons
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';

const OddsRoutes = {
  id: 'Odds-group',
  title: 'Odds Management',
  type: 'group',
  children: [
    {
      id: 'Odds-list',
      title: 'Odds List',
      type: 'item',
      url: '/odds/list',
      icon: LibraryAddCheckIcon,
      target: false
    }
  ]
};

export default OddsRoutes;
